import {
	ADMINKYCMAPPINGLIST_SUCCESS,
	ADMINKYCMAPPINGLIST_FAILED,
	RESET_ADMINKYCMAPPINGLIST,
	LOADING_ADMINKYCMAPPINGLIST,
	NETWORK_ERROR_ADMINKYCMAPPINGLIST
} from "../types/index";

const initialState = {
	isLoading: false,
	success: false,
	network: false,
	failed: false,
	data: {}
};

export default (state = initialState, action) => {
	switch (action.type) {
		case LOADING_ADMINKYCMAPPINGLIST:
			return {
				...state,
				isLoading: true,
				success: false,
				failed: false,
				network: false,
				data: {}
			};
		case ADMINKYCMAPPINGLIST_FAILED:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: true,
				network: false,
				data: action.payload
			};
		case ADMINKYCMAPPINGLIST_SUCCESS:
			return {
				...state,
				isLoading: false,
				success: true,
				failed: false,
				network: false,
				data: action.payload
			};
		case NETWORK_ERROR_ADMINKYCMAPPINGLIST:
			return {
				...state,
				isLoading: false,
				success: false,
				failed: false,
				network: true,
				data: {}
			};
		case RESET_ADMINKYCMAPPINGLIST:
			return (state = initialState);
		default:
			return state;
	}
};
